module.exports = "<div class=\"middle-box text-center animated fadeInDown wrap-mid-bx-tp\">\n  <h1>500</h1>\n  <h3 class=\"font-bold\">{{ 'INTERNAL_SERVER_ERROR' | translate}}</h3>\n\n  <div class=\"error-desc\">\n    {{ 'INTERNAL_SERVER_ERROR_DISCRETION' | translate}}\n    <!--<a href=\"index.html\" class=\"btn btn-primary m-t\">Dashboard</a>-->\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/error/error.component.html
// module id = ./src/app/shared/components/error/error.component.html
// module chunks = main